export const BANK_IMAGES = {
  envelo: 'https://data.imoje.pl/img/pay/envelo.png',
  nest: 'https://data.imoje.pl/img/pay/nest.svg',
  bspb: 'https://data.imoje.pl/img/pay/bspb.png',
  bs: 'https://data.imoje.pl/img/pay/bs.svg',
  plusbank: 'https://data.imoje.pl/img/pay/plusbank.png',
  pocztowy: 'https://data.imoje.pl/img/pay/pocztowy.svg',
  bnpparibas: 'https://data.imoje.pl/img/pay/bnpparibas.svg',
  bos: 'https://data.imoje.pl/img/pay/bos.png',
  citi: 'https://data.imoje.pl/img/pay/citi.png',
  millennium: 'https://data.imoje.pl/img/pay/millennium.svg',
  pbs: 'https://data.imoje.pl/img/pay/pbs.png',
  alior: 'https://data.imoje.pl/img/pay/alior.png',
  creditagricole: 'https://data.imoje.pl/img/pay/creditagricole.svg',
  ideabank: 'https://data.imoje.pl/img/pay/ideabank.png',
  noble: 'https://data.imoje.pl/img/pay/noble.png',
  getin: 'https://data.imoje.pl/img/pay/velo.svg',
  ipko: 'https://data.imoje.pl/img/pay/ipko.png',
  inteligo: 'https://data.imoje.pl/img/pay/inteligo.png',
  pekao24: 'https://data.imoje.pl/img/pay/pekao24.svg',
  bzwbk: 'https://data.imoje.pl/img/pay/bzwbk.svg',
  mtransfer: 'https://data.imoje.pl/img/pay/mbank.svg',
  ing: 'https://data.imoje.pl/img/pay/ing.png',
  orange: 'https://data.imoje.pl/img/pay/orange.png',
  deutschebank: 'https://data.imoje.pl/img/pay/deutchebank.svg',
  raiffeisenpolbank: 'https://data.imoje.pl/img/pay/raiffeisenpolbank.png'
};
